export const routes = [
  {
    path: "/apresentacoes",
    name: "apresentacoes",
    component: () =>
      import(
        /* webpackChunkName: "apresentacoes" */ "./components/List.vue"
      ),
    meta: {
      requiresAuth: true,
      requiresFullAdmin: true,
    },
  },
  {
    path: "/apresentacoes/editor/:slug?",
    name: "apresentacoes-editor",
    component: () =>
      import(
        /* webpackChunkName: "apresentacoes" */ "./components/Editor.vue"
      ),
    meta: {
      requiresAuth: true,
      requiresFullAdmin: true,
    },
  },
];
